module.exports = __webpack_public_path__ + "img/FigmaDDSSlicePNG54f9e3e5ad494c76b1e2601fb24819a6.54f9e3e5.png";